<div class="ui-fluid">
  <p-dropdown
    class="accept-reject-select"
    [appendTo]="appendTo"
    [options]="options"
    [(ngModel)]="value"
    (ngModelChange)="onModelChange()"
    placeholder="Select Value"
    [disabled]="readOnly"
    autoWidth="false"
  >
    <ng-template let-item pTemplate="selectedItem">
      <span>
        <i class="material-icons icon-style" [ngClass]="item.class">{{ item.icon }}</i>
      </span>
      <span class="text-style" [ngClass]="item.class">{{ item.label }}</span>
    </ng-template>
    <ng-template let-item pTemplate="item">
      <span>
        <i class="material-icons icon-style" [ngClass]="item.class">{{ item.icon }}</i>
      </span>
      <span class="text-style" [ngClass]="item.class">{{ item.label }}</span>
    </ng-template>
  </p-dropdown>
</div>
